/* ==========================================================================
   ImmuneShield Complex — theme.js
   Vanilla JS only. No dependencies.
   ========================================================================== */

(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {
    initAnnouncementMarquee();
    initStickyHeader();
    initMobileNav();
    initCartDrawer();
    initProductGallery();
    initQuantitySelector();
    initAddToCart();
    initStickyPurchaseBar();
    initBeforeAfterSwipe();
    initScrollAnimations();
    initAccordion();
    initCarousel();
  });

  /* ------------------------------------------------------------------
     Announcement marquee — pause on hover
  ------------------------------------------------------------------ */
  function initAnnouncementMarquee() {
    var bar = document.querySelector('[data-announcement-bar]');
    if (!bar) return;

    bar.addEventListener('mouseenter', function () {
      bar.setAttribute('data-paused', 'true');
    });
    bar.addEventListener('mouseleave', function () {
      bar.setAttribute('data-paused', 'false');
    });
  }

  /* ------------------------------------------------------------------
     Sticky header — opacity toggle on scroll
  ------------------------------------------------------------------ */
  function initStickyHeader() {
    var header = document.querySelector('[data-site-header]');
    if (!header) return;

    var sentinel = document.createElement('div');
    sentinel.style.position = 'absolute';
    sentinel.style.top = '0';
    sentinel.style.height = '1px';
    sentinel.style.width = '1px';
    header.insertAdjacentElement('beforebegin', sentinel);

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        header.setAttribute('data-scrolled', String(!entry.isIntersecting));
      });
    }, { threshold: 0 });

    observer.observe(sentinel);
  }

  /* ------------------------------------------------------------------
     Mobile nav — hamburger toggle + body scroll lock
  ------------------------------------------------------------------ */
  function initMobileNav() {
    var toggle = document.querySelector('[data-mobile-nav-toggle]');
    var close = document.querySelector('[data-mobile-nav-close]');
    var nav = document.querySelector('[data-mobile-nav]');
    if (!toggle || !nav) return;

    function open() {
      nav.setAttribute('data-state', 'open');
      nav.setAttribute('aria-hidden', 'false');
      toggle.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    }

    function closeNav() {
      nav.removeAttribute('data-state');
      nav.setAttribute('aria-hidden', 'true');
      toggle.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    }

    toggle.addEventListener('click', open);
    if (close) close.addEventListener('click', closeNav);

    nav.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', closeNav);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && nav.getAttribute('data-state') === 'open') {
        closeNav();
      }
    });
  }

  /* ------------------------------------------------------------------
     Cart drawer — open/close, Ajax add/update, count sync
  ------------------------------------------------------------------ */
  function initCartDrawer() {
    var drawer = document.querySelector('[data-cart-drawer]');
    if (!drawer) return;

    var overlay = drawer.querySelector('[data-cart-drawer-overlay]');
    var closeBtn = drawer.querySelector('[data-cart-drawer-close]');
    var openBtns = document.querySelectorAll('[data-cart-drawer-open]');

    function open() {
      drawer.setAttribute('data-state', 'open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }

    function close() {
      drawer.removeAttribute('data-state');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    openBtns.forEach(function (btn) {
      btn.addEventListener('click', open);
    });

    if (overlay) overlay.addEventListener('click', close);
    if (closeBtn) closeBtn.addEventListener('click', close);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.getAttribute('data-state') === 'open') {
        close();
      }
    });

    // Quantity controls inside drawer (Ajax /cart/change.js)
    drawer.addEventListener('click', function (e) {
      var decreaseBtn = e.target.closest('[data-cart-qty-decrease]');
      var increaseBtn = e.target.closest('[data-cart-qty-increase]');
      var removeBtn = e.target.closest('[data-cart-remove]');

      if (decreaseBtn || increaseBtn) {
        var item = e.target.closest('[data-cart-item]');
        var valueEl = item.querySelector('[data-cart-qty-value]');
        var qty = parseInt(valueEl.textContent, 10) || 1;
        qty = increaseBtn ? qty + 1 : Math.max(0, qty - 1);
        updateCartLine(item.dataset.key, qty);
      }

      if (removeBtn) {
        var removeItem = e.target.closest('[data-cart-item]');
        updateCartLine(removeItem.dataset.key, 0);
      }
    });

    function updateCartLine(key, quantity) {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity })
      })
        .then(function (res) { return res.json(); })
        .then(function (cart) { refreshCartDrawer(cart); })
        .catch(function (err) { console.error('Cart update failed', err); });
    }

    function refreshCartDrawer(cart) {
      updateCartCount(cart.item_count);

      var subtotal = drawer.querySelector('[data-cart-subtotal]');
      if (subtotal) {
        subtotal.textContent = formatMoney(cart.total_price);
      }

      var footer = drawer.querySelector('[data-cart-footer]');
      if (footer) footer.style.display = cart.item_count > 0 ? '' : 'none';

      var body = drawer.querySelector('[data-cart-drawer-body]');
      if (!body) return;

      if (cart.item_count === 0) {
        body.innerHTML =
          '<div class="cart-drawer__empty">' +
          '<p>Your bag is empty</p>' +
          '<a href="/" class="btn btn--primary">Continue Shopping</a>' +
          '</div>';
        return;
      }

      var list = document.createElement('ul');
      list.className = 'cart-drawer__items';
      list.setAttribute('data-cart-items', '');
      list.setAttribute('role', 'list');

      cart.items.forEach(function (item) {
        list.appendChild(buildCartItem(item));
      });

      body.innerHTML = '';
      body.appendChild(list);
    }

    function buildCartItem(item) {
      var li = document.createElement('li');
      li.className = 'cart-item';
      li.setAttribute('data-cart-item', '');
      li.dataset.key = item.key;

      var imageSrc = item.image ? item.image.replace(/(\.[a-zA-Z0-9]+)(\?|$)/, '_160x$1$2') : '';
      var variantTitle = item.variant_title ? '<p class="cart-item__variant">' + item.variant_title + '</p>' : '';

      li.innerHTML =
        '<div class="cart-item__image img-vignette">' +
          (imageSrc ? '<img src="' + imageSrc + '" alt="" width="80" height="80" loading="lazy">' : '') +
        '</div>' +
        '<div class="cart-item__details">' +
          '<a href="' + item.url + '" class="cart-item__title">' + item.product_title + '</a>' +
          variantTitle +
          '<div class="cart-item__qty" data-quantity-selector>' +
            '<button type="button" class="cart-item__qty-btn" data-cart-qty-decrease aria-label="Decrease quantity">−</button>' +
            '<span class="cart-item__qty-value" data-cart-qty-value>' + item.quantity + '</span>' +
            '<button type="button" class="cart-item__qty-btn" data-cart-qty-increase aria-label="Increase quantity">+</button>' +
          '</div>' +
        '</div>' +
        '<div class="cart-item__price">' + formatMoney(item.final_line_price) + '</div>' +
        '<button type="button" class="cart-item__remove" data-cart-remove aria-label="Remove ' + item.product_title + '">×</button>';

      return li;
    }

    window.ImmuneShieldCart = {
      open: open,
      close: close,
      refresh: refreshCartDrawer
    };
  }

  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
    });
  }

  function formatMoney(cents) {
    return '£' + (cents / 100).toFixed(2);
  }

  /* ------------------------------------------------------------------
     Product gallery — thumbnail click + swipe
  ------------------------------------------------------------------ */
  function initProductGallery() {
    var gallery = document.querySelector('[data-product-gallery]');
    if (!gallery) return;

    var slides = gallery.querySelectorAll('[data-gallery-slide]');
    var thumbs = gallery.querySelectorAll('[data-gallery-thumb]');
    var main = gallery.querySelector('.product-gallery__main');

    function showSlide(index) {
      slides.forEach(function (slide) {
        slide.classList.toggle('is-active', Number(slide.dataset.index) === index);
      });
      thumbs.forEach(function (thumb) {
        thumb.classList.toggle('is-active', Number(thumb.dataset.index) === index);
      });
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        showSlide(Number(thumb.dataset.index));
      });
    });

    // Touch swipe on mobile
    if (main) {
      var startX = 0;

      main.addEventListener('touchstart', function (e) {
        startX = e.touches[0].clientX;
      }, { passive: true });

      main.addEventListener('touchend', function (e) {
        var endX = e.changedTouches[0].clientX;
        var diff = startX - endX;
        var threshold = 40;
        if (Math.abs(diff) < threshold) return;

        var current = 0;
        slides.forEach(function (slide, i) {
          if (slide.classList.contains('is-active')) current = i;
        });

        var next = diff > 0 ? current + 1 : current - 1;
        next = Math.max(0, Math.min(slides.length - 1, next));
        showSlide(next);
      }, { passive: true });
    }
  }

  /* ------------------------------------------------------------------
     Quantity selector — +/- controls
  ------------------------------------------------------------------ */
  function initQuantitySelector() {
    document.querySelectorAll('[data-quantity-selector]').forEach(function (selector) {
      var input = selector.querySelector('[data-quantity-input]');
      var decrease = selector.querySelector('[data-quantity-decrease]');
      var increase = selector.querySelector('[data-quantity-increase]');
      if (!input) return;

      if (decrease) {
        decrease.addEventListener('click', function () {
          var value = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
          input.value = value;
        });
      }

      if (increase) {
        increase.addEventListener('click', function () {
          var value = (parseInt(input.value, 10) || 1) + 1;
          input.value = value;
        });
      }

      input.addEventListener('change', function () {
        var value = Math.max(1, parseInt(input.value, 10) || 1);
        input.value = value;
      });
    });
  }

  /* ------------------------------------------------------------------
     Add to cart — Ajax add + button state machine (idle/adding/added)
  ------------------------------------------------------------------ */
  function initAddToCart() {
    document.querySelectorAll('[data-add-to-cart]').forEach(function (button) {
      if (button.hasAttribute('data-bundle-add')) return; // handled by bundle script (product-hero / sticky bar)
      button.addEventListener('click', function () {
        if (button.dataset.state === 'adding') return;

        var variantId = button.dataset.variantId;
        if (!variantId) return;

        var form = button.closest('[data-product-form]');
        var quantityInput = form ? form.querySelector('[data-quantity-input]') : null;
        var quantity = quantityInput ? parseInt(quantityInput.value, 10) || 1 : 1;

        setButtonState(button, 'adding');

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: quantity })
        })
          .then(function (res) {
            if (!res.ok) throw new Error('Add to cart failed');
            return res.json();
          })
          .then(function () {
            return fetch('/cart.js');
          })
          .then(function (res) { return res.json(); })
          .then(function (cart) {
            updateCartCount(cart.item_count);
            setButtonState(button, 'added');

            if (window.ImmuneShieldCart) {
              window.ImmuneShieldCart.refresh(cart);
              window.ImmuneShieldCart.open();
            }

            setTimeout(function () {
              setButtonState(button, 'idle');
            }, 1500);
          })
          .catch(function (err) {
            console.error('Add to cart error', err);
            setButtonState(button, 'idle');
          });
      });
    });
  }

  function setButtonState(button, state) {
    var label = button.querySelector('[data-add-to-cart-label]');
    button.dataset.state = state;
    button.disabled = state === 'adding';

    if (!label) return;

    if (state === 'adding') {
      label.textContent = 'Adding...';
    } else if (state === 'added') {
      label.textContent = 'Added to Bag ✓';
    } else {
      label.textContent = 'Add to Cart';
    }
  }

  /* ------------------------------------------------------------------
     Sticky purchase bar — show/hide via Intersection Observer
  ------------------------------------------------------------------ */
  function initStickyPurchaseBar() {
    var bar = document.querySelector('[data-sticky-bar]');
    var mainCta = document.querySelector('#product-hero [data-add-to-cart]');
    if (!bar || !mainCta) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          bar.removeAttribute('data-state');
          bar.setAttribute('aria-hidden', 'true');
        } else if (entry.boundingClientRect.top < 0) {
          bar.setAttribute('data-state', 'visible');
          bar.setAttribute('aria-hidden', 'false');
        }
      });
    }, { threshold: 0 });

    observer.observe(mainCta);
  }

  /* ------------------------------------------------------------------
     Before/after swipe — drag handle, clip-path reveal
  ------------------------------------------------------------------ */
  function initBeforeAfterSwipe() {
    var frame = document.querySelector('[data-swipe-compare]');
    if (!frame) return;

    var handle = frame.querySelector('[data-swipe-handle]');
    var before = frame.querySelector('[data-swipe-before]');
    var after = frame.querySelector('[data-swipe-after]');
    var dragging = false;

    function setPosition(percent) {
      percent = Math.max(0, Math.min(100, percent));
      before.style.clipPath = 'inset(0 ' + (100 - percent) + '% 0 0)';
      after.style.clipPath = 'inset(0 0 0 ' + percent + '%)';
      handle.style.left = percent + '%';
      handle.setAttribute('aria-valuenow', Math.round(percent));
    }

    function moveFromEvent(clientX) {
      var rect = frame.getBoundingClientRect();
      var percent = ((clientX - rect.left) / rect.width) * 100;
      setPosition(percent);
    }

    function onPointerDown(e) {
      dragging = true;
      var clientX = e.touches ? e.touches[0].clientX : e.clientX;
      moveFromEvent(clientX);
    }

    function onPointerMove(e) {
      if (!dragging) return;
      var clientX = e.touches ? e.touches[0].clientX : e.clientX;
      moveFromEvent(clientX);
    }

    function onPointerUp() {
      dragging = false;
    }

    handle.addEventListener('mousedown', onPointerDown);
    handle.addEventListener('touchstart', onPointerDown, { passive: true });

    document.addEventListener('mousemove', onPointerMove);
    document.addEventListener('touchmove', onPointerMove, { passive: true });

    document.addEventListener('mouseup', onPointerUp);
    document.addEventListener('touchend', onPointerUp);

    // Keyboard support
    handle.addEventListener('keydown', function (e) {
      var current = parseFloat(handle.getAttribute('aria-valuenow')) || 50;
      if (e.key === 'ArrowLeft') setPosition(current - 5);
      if (e.key === 'ArrowRight') setPosition(current + 5);
    });
  }

  /* ------------------------------------------------------------------
     Scroll animations — fade-up with stagger
  ------------------------------------------------------------------ */
  function initScrollAnimations() {
    var items = document.querySelectorAll('.fade-up');
    if (!items.length) return;

    if (!('IntersectionObserver' in window)) {
      items.forEach(function (item) { item.classList.add('is-visible'); });
      return;
    }

    var observer = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });

    items.forEach(function (item) { observer.observe(item); });
  }

  /* ------------------------------------------------------------------
     FAQ accordion — one open at a time
  ------------------------------------------------------------------ */
  function initAccordion() {
    document.querySelectorAll('[data-accordion]').forEach(function (accordion) {
      var items = accordion.querySelectorAll('[data-accordion-item]');

      items.forEach(function (item) {
        var trigger = item.querySelector('[data-accordion-trigger]');
        var panel = item.querySelector('[data-accordion-panel]');

        trigger.addEventListener('click', function () {
          var isOpen = item.getAttribute('data-open') === 'true';

          items.forEach(function (other) {
            other.removeAttribute('data-open');
            other.querySelector('[data-accordion-trigger]').setAttribute('aria-expanded', 'false');
            other.querySelector('[data-accordion-panel]').style.maxHeight = null;
          });

          if (!isOpen) {
            item.setAttribute('data-open', 'true');
            trigger.setAttribute('aria-expanded', 'true');
            panel.style.maxHeight = panel.scrollHeight + 'px';
          }
        });
      });
    });
  }

  /* ------------------------------------------------------------------
     Review carousel — drag to scroll, dot sync, snap to card
  ------------------------------------------------------------------ */
  function initCarousel() {
    document.querySelectorAll('[data-carousel]').forEach(function (carousel) {
      var track = carousel.querySelector('[data-carousel-track]');
      var dots = carousel.querySelectorAll('[data-carousel-dot]');
      var items = carousel.querySelectorAll('[data-carousel-item]');
      if (!track) return;

      var isDown = false;
      var startX = 0;
      var scrollLeft = 0;

      track.addEventListener('mousedown', function (e) {
        isDown = true;
        track.classList.add('is-dragging');
        startX = e.pageX - track.offsetLeft;
        scrollLeft = track.scrollLeft;
      });

      ['mouseleave', 'mouseup'].forEach(function (evt) {
        track.addEventListener(evt, function () {
          isDown = false;
          track.classList.remove('is-dragging');
        });
      });

      track.addEventListener('mousemove', function (e) {
        if (!isDown) return;
        e.preventDefault();
        var x = e.pageX - track.offsetLeft;
        var walk = x - startX;
        track.scrollLeft = scrollLeft - walk;
      });

      // Dot sync on scroll
      if (dots.length && items.length) {
        var updateDots = function () {
          var index = Math.round(track.scrollLeft / track.clientWidth);
          dots.forEach(function (dot, i) {
            dot.classList.toggle('is-active', i === index);
          });
        };

        track.addEventListener('scroll', debounce(updateDots, 100));

        dots.forEach(function (dot) {
          dot.addEventListener('click', function () {
            var index = Number(dot.dataset.index);
            var item = items[index];
            if (item) {
              track.scrollTo({ left: item.offsetLeft - track.offsetLeft, behavior: 'smooth' });
            }
          });
        });
      }
    });
  }

  function debounce(fn, wait) {
    var timeout;
    return function () {
      clearTimeout(timeout);
      timeout = setTimeout(fn, wait);
    };
  }
})();
